import type { ToastType } from '../providers/ToastProvider';

const PENDING_TOAST_KEY = 'odo_pending_toast';

// Queue a toast for after a full page load: showToast only schedules React
// state, so a caller that reloads in the same block would never paint it.
export function stashToast(message: string, type: ToastType): void {
    try {
        sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify({ message, type }));
    } catch {
        /* best-effort: a lost message must not block the reload */
    }
}

/** Reads and consumes the queued toast, if any. */
export function takeStashedToast(): { message: string; type: ToastType } | null {
    try {
        const raw = sessionStorage.getItem(PENDING_TOAST_KEY);
        if (!raw) return null;
        sessionStorage.removeItem(PENDING_TOAST_KEY);
        const parsed = JSON.parse(raw) as { message?: unknown; type?: unknown };
        return typeof parsed.message === 'string' &&
            (parsed.type === 'success' || parsed.type === 'error')
            ? { message: parsed.message, type: parsed.type }
            : null;
    } catch {
        return null;
    }
}
